import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    StatusComponent,
} from "../../../common/component/Index";
import { Link } from 'react-router-dom';
import i18n from "../../../../../constants/initLng";
import { PATHS, TICKET, DETAIL_ACTIONS, DATE_TIME_FORMAT, ORDER } from "../../../../../constants/Define";
import { Descriptions } from 'antd';
import { isEqual, get, find, toArray } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import { TicketAssignConfig } from '../../../../../models/Ticket';
import Wrapper from './../../../common/component/Wrapper';

import './TicketAssignConfigDetail.less';
import { getLocaleFullName } from '../../../../../utils/commonUtils';
import Span from '../../../common/component/Span';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import Radio from '../../../common/component/Radio';
import moment from 'moment';
import Switch from '../../../common/component/Switch';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
};

export default class TicketAssignConfigDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            ticketAssignConfig: this.props.ticketState.detail.ticketAssignConfig,
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setTicketAssignConfigDetail(new TicketAssignConfig())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticketState.detail.ticketAssignConfig
            && !isEqual(nextProps.ticketState.detail.ticketAssignConfig, this.props.ticketState.detail.ticketAssignConfig)) {
            this.setState({
                ticketAssignConfig: nextProps.ticketState.detail.ticketAssignConfig,
                action: nextProps.ticketState.detail.ticketAssignConfig.id ? DETAIL_ACTIONS.UPDATE : this.state.action
            });
        }
    }

    render() {
        const { t, ticketState, userState } = this.props;
        const { isFetchingDetail } = ticketState;
        const { csUsers } = userState;
        const { action, validation, ticketAssignConfig } = this.state;
        return (
            <LoadingComponent spinning={isFetchingDetail}>
                <PageListComponent className="ticket-assign-config-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'ticketAssignConfigs'}
                        titleHeader={
                            Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.ticket.ticketAssignConfigs')}`.toLowerCase()))
                        }

                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isGetItem={false}
                        action={action}
                        onClickBack={this.onClickBack}
                        submitButtonRight={true}
                    >
                        <Wrapper className="col-md-12 row m-0 pt-4 bg-white">
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    dataValidation={ticketAssignConfig.userId}
                                    validation={validation.userId}
                                    labelTitle={t(`item.ticket.user`)}
                                >
                                    <AntSelect className="select-user"
                                        showArrow showSearch
                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ticket.assignee")).toLowerCase())}
                                        value={ticketAssignConfig.userId}
                                        onChange={id => this.onChangeDetail('userId', id)}
                                        style={{ width: '100%' }}
                                        filterOption={this.selectFilterSearch}
                                    >
                                        {csUsers.map(user => (
                                            <AntOption key={user.id} value={user.id}>{getLocaleFullName(user.firstname, user.lastname)}</AntOption>
                                        ))}
                                    </AntSelect>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    dataValidation={ticketAssignConfig.orderItemType}
                                    validation={validation.orderItemType}
                                    labelTitle={t(`item.ticket.orderItemType`)}
                                >
                                    {/* <Radio.Group value={ticketAssignConfig.orderItemType}
                                        onChange={e => this.onChangeDetail('orderItemType', e.target.value)}>
                                        {toArray(ORDER.TYPES).map(type => !type.hide && (
                                            <Radio key={type.key} value={type.id}>{t(`item.order.orderTypes.${type.key}`)}</Radio>
                                        ))}
                                    </Radio.Group> */}
                                    <AntSelect className="select-order-type"
                                        showArrow showSearch
                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ticket.orderItemType")).toLowerCase())}
                                        value={ticketAssignConfig.orderItemType}
                                        onChange={id => this.onChangeDetail('orderItemType', id)}
                                        style={{ width: '100%' }}
                                        filterOption={this.selectFilterSearch}
                                    >
                                        {toArray(ORDER.TYPES).map(type => !type.hide && (
                                            <AntOption key={type.key} value={type.id}>{t(`item.order.orderTypes.${type.key}`)}</AntOption>
                                        ))}
                                    </AntSelect>
                                </FormWrapperInputComponent>

                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.ticket.assignedDays`)}
                                >
                                    <Wrapper className="ant-btn-group assignedDays">
                                        {(moment.localeData('en').weekdays() || []).map(day => {
                                            const dayKey = day.toLowerCase();
                                            return <Span key={dayKey}
                                                className={`ant-btn ant-btn-${ticketAssignConfig[dayKey] ? 'primary' : 'default'}`}
                                                onClick={e => this.onChangeDetail(dayKey, !ticketAssignConfig[dayKey])}
                                            >{this.props.t(`item.ticket.${dayKey}`)}</Span>
                                        })}
                                    </Wrapper>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.ticket.status`)}
                                >
                                    <br />
                                    <Switch labelRight={true}
                                        label={ticketAssignConfig.isDisabled ? t(`item.ticket.isDisabled`) : t(`item.ticket.isEnabled`)}
                                        checked={!ticketAssignConfig.isDisabled}
                                        onChange={checked => this.onChangeDetail('isDisabled', !ticketAssignConfig.isDisabled)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match, ticketState } = this.props;
        let ticketAssignConfig = this.state.ticketAssignConfig;
        if ((Object.keys(match.params).length > 0 && match.params.id)) {
            const ticketAssignConfigs = ticketState.ticketAssignConfigs;
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            ticketAssignConfig = find(ticketAssignConfigs, item => item.id === id) || ticketAssignConfig;
            if (ticketAssignConfig) this.setState({ ticketAssignConfig });
            this.props.getTicketAssignConfigDetail(id);
        }
        this.props.getCSUsers();
    }

    onChangeDetail = (fieldName, value) => {
        const ticketAssignConfig = this.state.ticketAssignConfig;
        ticketAssignConfig[fieldName] = value;
        this.setState({ ticketAssignConfig });
    };

    onSubmit = (e) => {
        if (e) e.preventDefault();
        if (this.validate()) {
            this.updateDetail()
        }
    };

    onClickBack = () => {
        this.props.history.push(PATHS.TICKET_ASSIGN_CONFIG.LIST.path);
    }

    validate(reset = false) {
        const { t } = this.props;
        const { ticketAssignConfig } = this.state;
        if (reset) {
            Func.multipleValidate(ticketAssignConfig, undefined, {});
            this.setState({ validation: {} });
        }
        let validate = {
            required: {
                userId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.user`)),
                orderItemType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.orderItemType`)),
            },
        };
        let valueValidate = {};
        const result = Func.multipleValidate(ticketAssignConfig, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    updateDetail() {
        const { ticketAssignConfig, action } = this.state;

        if (action === DETAIL_ACTIONS.UPDATE) {
            this.props.updateTicketAssignConfig(ticketAssignConfig);
        } else {
            this.props.createTicketAssignConfig(ticketAssignConfig);
        }
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

}

TicketAssignConfigDetail.defaultProps = {

}
